import { PairSessionResponseSchema, type PairSessionResponse } from '@trames/shared/schemas';

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
  ) {
    super(`api ${status} ${code}`);
  }
}

export class ApiSchemaError extends Error {
  readonly code = 'schema_violation' as const;
}

/**
 * Crea una sesión llamando al server-api. Valida la respuesta con Zod —
 * si el servidor emite algo fuera de schema, lanza ApiSchemaError (defensa
 * frente a downgrade del backend, ADR-0002 §"Política inmutable").
 */
export async function createSession(): Promise<PairSessionResponse> {
  const res = await fetch('/v1/sessions', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({}),
  });

  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new ApiError(res.status, body.error ?? 'unknown');
  }

  const json: unknown = await res.json();
  const parsed = PairSessionResponseSchema.safeParse(json);
  if (!parsed.success) {
    throw new ApiSchemaError();
  }
  return parsed.data;
}
